import { render, staticRenderFns } from "./SvgGen.vue?vue&type=template&id=489ad15f&lang=pug&"
import script from "./SvgGen.vue?vue&type=script&lang=ts&"
export * from "./SvgGen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports